import { useRouter } from "next/router";
import React from "react";
import { Producer } from "../../../context/wineContext/reducer";

type ProducerResultProps = {
  producer: Producer;
};

const ProducerResult = ({ producer }: ProducerResultProps) => {
  const { producer_name, slug, association_stats, regional_info } = producer;
  const router = useRouter();
  const handleClick = () => {
    const term = router.query["term"];

    router.push({
      pathname: "/producers/" + slug,
      query: {
        term
      }
    }, undefined, { shallow: true })
  }

  const baseWineStatsStr = React.useMemo(() => {
    if (association_stats) {
      return `${association_stats.base_wine_total} Wines, ${association_stats.wine_vintage_total} Vintages`;
    } else {
      return null;
    }
  }, [association_stats])

  return (
    <div 
      className="transition rounded shadow hover:shadow-md px-4 py-2 flex items-center cursor-pointer"
      onClick={handleClick}
      onKeyDown={(e) => {if (e.key === "Enter") handleClick()}}
      role="button"
      tabIndex={0}
      aria-label="Producer Result"
    >
      <div className="w-full">
        <div className="font-bold text-lg">
          {producer_name}
        </div>
        {regional_info && (
          <div className="text-sm">
            {regional_info}
          </div>
        )}
      </div>

      <div className="w-72 text-right">
        <div className="text-sm">
          { baseWineStatsStr }
        </div>
        <div className="font-light text-sm">
          { producer.association_stats.wine_total } Reviews
        </div>
      </div>
    </div>
  )
}

export default ProducerResult;